import { Division, JobTitle } from '@connect-x-app/shared-domain-models';

import { UserUtil } from '../users';

export const isEmptyString = (value?: string | null): boolean => !value?.trim();

export const replaceJobTitlePlaceholders = (text?: string | null): string => {
  if (text) {
    const regex = /\{\{(.+?)\}\}/;
    const match = regex.exec(text);

    if (match?.[1]) {
      const valueToReplace = match[0];
      const replaceValue: Division = UserUtil.getDivision(match[1] as JobTitle);
      text = text.replace(valueToReplace, replaceValue);
    }
  }

  return text ?? '';
};

export const getCustomCrewTitle = (jobTitle: JobTitle, jobTitleCustom?: string | null): string | null => {
  const customName = jobTitleCustom?.trim();

  return customName && customName !== String(jobTitle) ? replaceJobTitlePlaceholders(customName) : null;
};

export const createReadableTextFromList = (
  stringsList: string[],
  separator: string,
  endSeparator?: string,
  shouldUseQuotes: boolean = false,
) => {
  const quotes = shouldUseQuotes ? '"' : '';
  const quotedSeparator = `${quotes}${separator}${quotes}`;
  const temporaryRolesText = `${quotes}${stringsList.join(quotedSeparator)}${quotes}`;
  const lastSeparatorIndex = temporaryRolesText.lastIndexOf(separator);

  if (!endSeparator || lastSeparatorIndex === -1) {
    return temporaryRolesText;
  }

  const partBeforeLastComma = temporaryRolesText.slice(0, lastSeparatorIndex);
  const partAfterLastComma = temporaryRolesText.slice(lastSeparatorIndex + 1).trimStart();

  return `${partBeforeLastComma} ${endSeparator} ${partAfterLastComma}`;
};

export const semverToVersionNumber = (version: string): number => {
  const [major, minor, patch] = version.split('.').map(Number);

  if ([major, minor, patch].some(v => v === undefined || Number.isNaN(v))) {
    // fallback to 0 if we ever get a version that is not semver compliant (i.e., 1.2.3-alpha, 1.2)
    return 0;
  }

  // Needed to prevent collisions (i.e., 1.2.31 and 12.3.1), this is fail-safe unless we go above 1000 for a major,
  // minor or patch version. Which is very unlikely.
  return Number(
    `${major.toString().padStart(3, '0')}` + `${minor.toString().padStart(3, '0')}` + `${patch.toString().padStart(3, '0')}`,
  );
};
